import { StepData } from '@/lib/Steppers';

export enum CREATE_DATA_SOURCE_AMAZON_S3 {
  NAME_AND_BUCKET,
  HEADER,
  DATA_TYPE,
  MAP_COLUMNS,
  CONFIRMATION,
}

export const CREATE_DATA_SOURCE_AMAZON_S3_STEPS: ReadonlyArray<StepData<number>> = [
  {
    id: CREATE_DATA_SOURCE_AMAZON_S3.NAME_AND_BUCKET,
    title: 'data_source_edit:file.steps.name_and_bucket',
  },
  {
    id: CREATE_DATA_SOURCE_AMAZON_S3.HEADER,
    title: 'data_source_edit:file.steps.header',
  },
  {
    id: CREATE_DATA_SOURCE_AMAZON_S3.DATA_TYPE,
    title: 'data_source_edit:file.steps.data_type',
  },
  {
    id: CREATE_DATA_SOURCE_AMAZON_S3.MAP_COLUMNS,
    title: 'data_source_edit:file.steps.map_columns',
  },
  {
    id: CREATE_DATA_SOURCE_AMAZON_S3.CONFIRMATION,
    title: 'data_source_edit:file.steps.confirmation',
  },
];
